"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line no-use-before-define
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const use_query_params_1 = require("use-query-params");
const react_hooks_1 = require("@apollo/react-hooks");
function StockManagementView(props) {
    return (react_1.default.createElement(react_hooks_1.ApolloProvider, { client: props.client },
        react_1.default.createElement(use_query_params_1.QueryParamProvider, { ReactRouterRoute: react_router_dom_1.Route },
            react_1.default.createElement(react_router_dom_1.Switch, null,
                react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: props.path, component: (args) => props.stocksView(args) }),
                react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: `${props.path}/download`, component: (args) => props.downloadView(args) }),
                react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: `${props.path}/:stockId`, component: (args) => props.stockRecordsView(args) })))));
}
exports.default = StockManagementView;
